import { ArrowDownIcon, ArrowUpIcon, ChevronsUpDownIcon } from 'lucide-react';

import { cn } from '../../utils/cn';

import { Button } from '../ui/button';

export function DataTableColumnHeader({ column, title, className }) {
  if (!column.getCanSort()) {
    return <div className={cn(className)}>{title}</div>;
  }

  return (
    <div className={cn('flex items-center space-x-2', className)}>
      <Button
        variant="ghost"
        size="sm"
        className={cn(
          '-ml-3 h-8',
          (column.getIsSorted() === 'desc' || column.getIsSorted() === 'asc') &&
            'bg-accent text-accent-foreground',
        )}
        onClick={() => {
          if (column.getIsSorted() === 'desc') {
            column.toggleSorting(false);
          } else if (column.getIsSorted() === 'asc') {
            column.clearSorting();
          } else {
            column.toggleSorting(true);
          }
        }}
      >
        <span>{title}</span>
        {column.getIsSorted() === 'desc' ? (
          <ArrowDownIcon />
        ) : column.getIsSorted() === 'asc' ? (
          <ArrowUpIcon />
        ) : (
          <ChevronsUpDownIcon />
        )}
      </Button>
    </div>
  );
}
